import {useLocale} from "i18n";
import Seo from "../seo/Seo";
import {ZeroKnowledgeContent} from "../home/landing/ZeroKnowledgeContent";
import {zeroKnowledgeCopy} from "../home/landing/copy/zeroKnowledge";

/**
 * Public, pre-rendered **Zero-Knowledge / E2EE** explainer page (`/zero-knowledge`, issue ui#133).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): mounts `<Seo>` + the page body. SEO strings and
 * body copy live in {@link ../home/landing/copy/zeroKnowledge.ts}, so a content agent edits only that
 * module and {@link ../home/landing/ZeroKnowledgeContent.tsx}, never this wrapper. The canonical URL is
 * derived from `path` by `<Seo>` per active locale, so the `/ro` mirror needs no separate wiring.
 */
export function Component() {
	const {locale} = useLocale();
	const {seo} = zeroKnowledgeCopy[locale];
	return (
		<>
			<Seo title={seo.title} description={seo.description} path="/zero-knowledge"/>
			<ZeroKnowledgeContent/>
		</>
	);
}
